import getSurfaceStore from '../store/store';
import { mutatorAction } from 'satcheljs';

/**
 * MutatorAction to set isSurfaceReloadPending value
 * @param isPending Whether reload of surface is pending is not
 */
const setIsSurfaceReloadPending = mutatorAction(
    'setIsSurfaceReloadPending',
    (isPending: boolean) => {
        getSurfaceStore().isSurfaceReloadPending = isPending;
    }
);

export default setIsSurfaceReloadPending;
